import { render, staticRenderFns } from "./NewLeadBtn.vue?vue&type=template&id=1af0af72&scoped=true&"
import script from "./NewLeadBtn.vue?vue&type=script&lang=js&"
export * from "./NewLeadBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af0af72",
  null
  
)

export default component.exports